import { apiClient } from './client';

export interface TikTokPromoCampaign {
  id: string;
  title: string;
  tiktokUrl: string;
  imageUrl: string;
  enabled: boolean;
  weight: number;
  oncePerUser: boolean;
  showAfterViews: number;
  trackClicks: boolean;
  stats: {
    impressions: number;
    clicks: number;
    lastImpressionAt: string | null;
    lastClickAt: string | null;
  };
  startsAt: string | null;
  endsAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TikTokPromoCampaignPayload {
  title: string;
  tiktokUrl: string;
  imageUrl: string;
  enabled: boolean;
  weight: number;
  oncePerUser: boolean;
  showAfterViews: number;
  trackClicks: boolean;
  startsAt: string | null;
  endsAt: string | null;
}

export interface TikTokPromoGithubStatus {
  configured: boolean;
  repo: string | null;
  branch: string;
  path: string;
  rawUrl: string | null;
  lastPublishedAt: string | null;
  lastPublishSha: string | null;
  lastPublishError: string | null;
}

export const tiktokPromoApi = {
  listCampaigns: () =>
    apiClient.get<TikTokPromoCampaign[]>('/api/tt/campaigns', {
      params: { _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
    }).then((res) => res.data),
  createCampaign: (payload: TikTokPromoCampaignPayload) =>
    apiClient.post<TikTokPromoCampaign>('/api/tt/campaigns', payload).then((res) => res.data),
  updateCampaign: (id: string, payload: Partial<TikTokPromoCampaignPayload>) =>
    apiClient.patch<TikTokPromoCampaign>(`/api/tt/campaigns/${id}`, payload).then((res) => res.data),
  resetCampaignViews: (id: string) =>
    apiClient.post<TikTokPromoCampaign>(`/api/tt/campaigns/${id}/reset-views`).then((res) => res.data),
  resolveLink: (url: string) =>
    apiClient.post<{ videoId: string; deepLink: string }>('/api/tt/resolve-link', { url }).then((res) => res.data),
  getGithubStatus: () =>
    apiClient.get<TikTokPromoGithubStatus>('/api/tt/github', {
      params: { _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
    }).then((res) => res.data),
  publishGithubConfig: () =>
    apiClient.post<TikTokPromoGithubStatus>('/api/tt/github/publish').then((res) => res.data),
  deleteCampaign: (id: string) => apiClient.delete(`/api/tt/campaigns/${id}`).then(() => undefined),
};
